import { render } from "./MediaUploader.vue?vue&type=template&id=39d956d6&scoped=true"
import script from "./MediaUploader.vue?vue&type=script&lang=js"
export * from "./MediaUploader.vue?vue&type=script&lang=js"

import "./MediaUploader.vue?vue&type=style&index=0&id=39d956d6&scoped=true&lang=css"

import exportComponent from "/home/cm/project/golinker/admin-panel/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-39d956d6"]])

export default __exports__